import { navigate } from "../router";

export function NotFoundPage(): JSX.Element {
  return (
    <div style={{ padding: "32px" }}>
      <h1>ページが見つかりません</h1>
      <p>URL を確認するか、ダッシュボードへお戻りください。</p>
      <button
        type="button"
        onClick={() => navigate("/")}
        style={{
          marginTop: "16px",
          padding: "8px 16px",
          borderRadius: "4px",
          border: "1px solid var(--color-border)",
          background: "var(--color-surface)",
        }}
      >
        ダッシュボードへ戻る
      </button>
    </div>
  );
}
